export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14330.f5648adc.jpg";